/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ExtendApplyingPlanSuccessResponseData,
    ExtendApplyingPlanSuccessResponseDataFromJSON,
    ExtendApplyingPlanSuccessResponseDataFromJSONTyped,
    ExtendApplyingPlanSuccessResponseDataToJSON,
} from './ExtendApplyingPlanSuccessResponseData';

/**
 * 
 * @export
 * @interface ExtendApplyingPlanSuccessResponse
 */
export interface ExtendApplyingPlanSuccessResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof ExtendApplyingPlanSuccessResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof ExtendApplyingPlanSuccessResponse
     */
    message: string;
    /**
     * 
     * @type {ExtendApplyingPlanSuccessResponseData}
     * @memberof ExtendApplyingPlanSuccessResponse
     */
    data: ExtendApplyingPlanSuccessResponseData;
}

export function ExtendApplyingPlanSuccessResponseFromJSON(json: any): ExtendApplyingPlanSuccessResponse {
    return ExtendApplyingPlanSuccessResponseFromJSONTyped(json, false);
}

export function ExtendApplyingPlanSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtendApplyingPlanSuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ExtendApplyingPlanSuccessResponseDataFromJSON(json['data']),
    };
}

export function ExtendApplyingPlanSuccessResponseToJSON(value?: ExtendApplyingPlanSuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ExtendApplyingPlanSuccessResponseDataToJSON(value.data),
    };
}

